var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import CalendarIcon from '@heroicons/react/outline/CalendarIcon.js';
import { Input } from '../Input/index.js';
import { useUniqueId } from '../utils/unique-id.js';
import { RangeCalendar } from './RangeCalendar.js';
import { useDatePicker } from './useDatePicker.js';
import { cleanDateRange } from './utils.js';
export const DateRangePicker = (_a) => {
    var { invalid, onChange, value, inline = false } = _a, rest = __rest(_a, ["invalid", "onChange", "value", "inline"]);
    const prefix = useUniqueId('DateRangePicker');
    const shouldAdjust = useRef(true);
    const prevValueRef = useRef(value);
    const handleOnChange = (dates) => {
        if (!Array.isArray(dates) || dates.length !== 2) {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(cleanDateRange(dates));
    };
    const { startInputField, calendarRef } = useDatePicker(Object.assign({ value: cleanDateRange(value), onChange: handleOnChange, mode: 'range', prefix, allowInput: false, noCalendar: inline, enableTime: false, showMonths: 2 }, rest));
    useEffect(() => {
        if (calendarRef.current) {
            const prevValue = prevValueRef.current;
            if (Array.isArray(value)) {
                if (shouldAdjust.current) {
                    if (!value) {
                        calendarRef.current.changeMonth(-1);
                    }
                    if ((value === null || value === void 0 ? void 0 : value.length) === 2) {
                        const [start, end] = value;
                        if ((prevValue === null || prevValue === void 0 ? void 0 : prevValue.length) === 2) {
                            const [prevStart, prevEnd] = prevValue;
                            if (start.toString() !== prevStart.toString() &&
                                end.toString() === prevEnd.toString()) {
                                calendarRef.current.jumpToDate(start, false);
                            }
                            else {
                                calendarRef.current.jumpToDate(end, false);
                                calendarRef.current.changeMonth(-1);
                            }
                        }
                        else {
                            calendarRef.current.jumpToDate(end, false);
                            calendarRef.current.changeMonth(-1);
                        }
                    }
                }
                else {
                    shouldAdjust.current = true;
                }
                prevValueRef.current = value;
            }
        }
    }, [calendarRef, value]);
    return (React.createElement("div", { className: "space-y-1 w-[308px]" },
        React.createElement(Input, { ref: startInputField, invalid: invalid, leadingIcon: React.createElement(CalendarIcon, { className: "h-5 w-5", "aria-hidden": "true" }) }),
        inline && React.createElement(RangeCalendar, Object.assign({ value: value, onChange: onChange }, rest))));
};
//# sourceMappingURL=DateRangePicker.js.map